export default "__VITE_ASSET__iO$nyJnc__"